import './core/Sentry'
import 'console-polyfill'
import 'chosen-js'
// jquery utils
import './plugins/nette.ajax'
import './plugins/history.ajax'
import './plugins/jquery.ui.sortable'
import 'bootstrap'
import 'bootstrap-datepicker'
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.cs'
import 'ublaboo-datagrid'
// import 'ublaboo-datagrid/assets/datagrid-instant-url-refresh'
import 'ublaboo-datagrid/assets/datagrid-spinners'
// plugins
import './plugins/fileinput'
import './plugins/focus-point'
import './plugins/giant.autosubmit'
import './plugins/giant.ckeditor'
import './plugins/giant.datepicker'
import './plugins/giant.dropzone'
import './plugins/giant.image-area'
import './plugins/giant.sortable'
import './plugins/giant.kanban'
import './plugins/substitute'
// components
import '../components/giant-auto-url'
import '../components/giant-cloner'
import '../components/giant-show-if'
import '../components/giant.batch-operation'
import '../components/giant.chosen'
import '../components/giant.help'
import '../components/giant.item-selector'
import '../components/giant.switcher'
import '../components/giant.tree-selector'
import '../components/giant.tree'
// modules
import './modules/anchor-watcher'
import './modules/article-tabs'
import './modules/campaign-progressbar'
import './modules/category-products'
import './modules/chart-donut'
import './modules/chart-stack-column'
import './modules/chart-stack'
import './modules/chart-reports'
import './modules/reports-period'
import './modules/chart-stats'
import './modules/checkbox-toggle'
import './modules/data-confirm'
import './modules/dropdown-scrollbar'
import './modules/filter'
import './modules/loading'
import './modules/location-vector'
import './modules/nav'
import './modules/opening-hours-autofill'
import './modules/switch-center'
import './modules/search-phrase-pair'
import './modules/trigger'

import $ from 'jquery'
import Switchery from 'switchery/standalone/switchery'

// nette
import Nette from './nette/NetteForms/netteForms.js'

const { forEach } = Array.prototype

Nette.initOnLoad()
window.Nette = Nette

if ($.nette) {
    $.nette.init()

    $.nette.ext('update', {
        success: function (payload) {
            if (payload.snippets) {
                Object.keys(payload.snippets).forEach(function (elementId) {
                    $('#' + elementId).trigger('dom:change')
                })
            }
        },
    })
}

try {
    Object.assign({})
} catch (e) {}

document.querySelectorAll('.js-switch')::forEach((element) => {
    new Switchery(element, {
        color: '#1c84c6',
        size: 'small',
    })
})
